import type { UIComponent } from '@gik/core/types/UI';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { FlexGrid } from '@gik/ui-legacy/FlexGrid';
import React from 'react';
import { UserWallets } from './UserWallets';

export type UserWalletsSectionProps = UIComponent & {};

const blockName = 'user-groups-section';

export const UserWalletsSection = ({ className, ...otherProps }: UserWalletsSectionProps) => {
  const bem = useBemCN(blockName);

  return (
    <div {...bem(null, null, 'tw-flex-1')} {...otherProps}>
      <FlexGrid {...bem('header')}>
        <h2 {...bem('title')}>Inkind Wallets</h2>

        {/* <div>
          <Switch labelBefore="HIDE" />
        </div> */}
      </FlexGrid>
      <p {...bem('description')}>These hold the gifts you’ve received through your InKind Page.</p>

      <UserWallets />
    </div>
  );
};
